import React, { PropsWithChildren } from 'react';
import { Box, Typography, SxProps } from '@mui/material';

const containerSx: SxProps = {
  display: 'flex',
  flexDirection: 'row'
};

const numberSx: SxProps = {
  fontSize: '20px'
};

const contentContainerSx: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  ml: '18px',
  flex: 1
};

const titleSx: SxProps = {
  fontSize: '20px'
};

const descriptionSx: SxProps = {
  fontSize: '16px',
  mt: '3px'
};

const childrenContainerSx: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  mt: '15px'
};

type Props = PropsWithChildren<{
  number: number;
  title: string;
  description: string;
  sx?: SxProps;
}>;

export const NumberedSectionHeader: React.FC<Props> = ({
  number,
  title,
  description,
  sx,
  children
}) => {
  return (
    <Box sx={{ ...containerSx, ...sx }}>
      <Typography sx={numberSx}>{number}.</Typography>
      <Box sx={contentContainerSx}>
        <Typography sx={titleSx}>{title}</Typography>
        <Typography sx={descriptionSx}>{description}</Typography>
        {children && <Box sx={childrenContainerSx}>{children}</Box>}
      </Box>
    </Box>
  );
};
